
export default {
  name: "CardEsoProfile",
  props: {
    id: Number,
    to: String,
    name: String,
    cover: String,
    thumbnail: String,
    owned: Boolean,
    status: String,
    phone: String,
    email: String,
    address: String,
    website: String,
    description: String,
    editable: Boolean,
    showReport: Boolean,
    establishYear: [String, Number],
    incorporatedDate: [String, Number],
    industries: { type: Array, default: () => [] },
    lookingAt: { type: Array, default: () => [] },
    investmentStage: { type: Array, default: () => [] },
  },
  methods: {
    editProfile() {
      this.$emit("edit");
    },
    report() {
      this.$refs.formReport.openForm(this.id, "startup");
    },
  },
};
